import { Pipe, PipeTransform } from '@angular/core';
import { inject } from '@angular/core';
import { Observable, of, take } from 'rxjs';
import { LocalizationService } from '@capital-access/common/localization';
import { BaseAsyncPipe } from '@capital-access/common/utils';
import { TARGETING_COMMON_KEY } from '../constants';

@Pipe({
  name: 'caNAValue',
  standalone: true
})
export class NaValuePipe extends BaseAsyncPipe<string, string> implements PipeTransform {
  private localizationService = inject(LocalizationService);

  getTransformer(value?: string | null): Observable<string> {
    if (value === null || value === undefined || value === '') {
      return this.localizationService.localize('notApplicable', {}, { scope: TARGETING_COMMON_KEY }).pipe(take(1));
    }
    return of(value as string);
  }
}
